import './cookieconsent.umd.js';

CookieConsent.run({
    guiOptions: {
        consentModal: {
            layout: "box",
            position: "bottom right",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            readOnly: true
        },
        analytics: {},
    },
    language: {
        default: "en",
        autoDetect: "browser",
        translations: {
            de: {
                consentModal: {
                    title: "Datenschutzeinstellungen",
                    description: "Wir verwenden Cookies und andere Technologien auf unserer Website. Einige von ihnen sind essenziell, während andere uns helfen, diese Website und Ihre Erfahrung zu verbessern. Personenbezogene Daten können verarbeitet werden (z. B. IP-Adressen), z. B. für personalisierte Anzeigen und Inhalte oder Anzeigen- und Inhaltsmessung.",
                    acceptAllBtn: "Alle akzeptieren",
                    acceptNecessaryBtn: "Alle ablehnen",
                    showPreferencesBtn: "Einstellungen verwalten",
                    footer: "<a target=\"_blank\" href=\"https://www.alpha-plan.de/datenschutz/\">Datenschutz</a>\n<a target=\"_blank\" href=\"https://www.alpha-plan.de/impressum/\">Impressum</a>"
                },
                preferencesModal: {
                    title: "Präferenzen für die Zustimmung",
                    acceptAllBtn: "Alle akzeptieren",
                    acceptNecessaryBtn: "Alle ablehnen",
                    savePreferencesBtn: "Einstellungen speichern",
                    closeIconLabel: "Modal schließen",
                    serviceCounterLabel: "Dienstleistungen",
                    sections: [
                        {
                            title: "Verwendung von Cookies",
                            description: "Hier finden Sie eine Übersicht über alle verwendeten Cookies. Sie können Ihre Einwilligung zu ganzen Kategorien geben oder sich weitere Informationen anzeigen lassen und so nur bestimmte Cookies auswählen."
                        },
                        {
                            title: "Streng Notwendige Cookies <span class=\"pm__badge\">Immer Aktiviert</span>",
                            description: "Essenzielle Cookies ermöglichen grundlegende Funktionen und sind für die einwandfreie Funktion der Website erforderlich.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: "Analytische Cookies",
                            description: "Statistik Cookies erfassen Informationen anonym. Diese Informationen helfen uns zu verstehen, wie unsere Besucher unsere Website nutzen.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Weitere Informationen",
                            description: "Wenn Sie Fragen in Bezug auf Cookies und Ihre Wahlmöglichkeiten haben, wenden Sie sich bitte an <a class=\"cc__link\" href=\"mailto:kontakt@alpha-plan.de\">kontakt@alpha-plan.de</a>."
                        }
                    ]
                }
            },
            en: {
                consentModal: {
                    title: "Privacy settings",
                    description: "We use cookies and other technologies on our website. Some of them are essential, while others help us to improve this website and your experience. Personal data may be processed (e.g. IP addresses), e.g. for personalized ads and content or ad and content measurement.",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject all",
                    showPreferencesBtn: "Manage preferences",
                    footer: "<a target=\"_blank\" href=\"https://www.alpha-plan.de/en/datenschutz-en/\">Privacy Policy</a>\n<a target=\"_blank\" href=\"https://www.alpha-plan.de/en/imprint/\">Imprint</a>"
                },
                preferencesModal: {
                    title: "Consent Preferences Center",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject all",
                    savePreferencesBtn: "Save preferences",
                    closeIconLabel: "Close modal",
                    serviceCounterLabel: "Service|Services",
                    sections: [
                        {
                            title: "Cookie Usage",
                            description: "Here you will find an overview of all cookies used. You can give your consent to entire categories or have further information displayed and thus select only certain cookies."
                        },
                        {
                            title: "Strictly Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
                            description: "Essential cookies enable basic functions and are necessary for the proper functioning of the website.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: "Analytics Cookies",
                            description: "Statistics cookies collect information anonymously. This information helps us to understand how our visitors use our website.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "More information",
                            description: "If you have any questions regarding cookies and your choices, please contact <a class=\"cc__link\" href=\"mailto:kontakt@alpha-plan.de\">kontakt@alpha-plan.de</a>."
                        }
                    ]
                }
            }
        }
    }
});